import styled from "styled-components";

export const HintRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  margin-top: ${({ theme }) => theme.spacing[3]};
  padding-left: ${({ theme }) => theme.spacing[3]};
  color: ${({ theme }) => theme.grey3};
  font-family: ${({ theme }) => theme.p4r.ff};
  font-size: ${({ theme }) => theme.p4r.fs};
  letter-spacing: ${({ theme }) => theme.p4r.letterSpacing};
  min-height: 18px;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transition: opacity 0.18s ease;

  .hint-icon {
    flex-shrink: 0;
    color: ${({ theme }) => theme.grey3};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.p3r.fs};
    padding-left: ${({ theme }) => theme.spacing[3]};
  }
`;

export const HintLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  margin-left: ${({ theme }) => theme.spacing[2]};
  font: inherit;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.55 : 1)};

  color: ${({ theme }) => theme.primary};

  &:hover,
  &:focus-visible {
    text-decoration: ${({ $disabled }) => ($disabled ? "none" : "underline")};
    outline: none;
  }
`;
